import { render } from "./Exma.vue?vue&type=template&id=66c84359"
import script from "./Exma.vue?vue&type=script&lang=js"
export * from "./Exma.vue?vue&type=script&lang=js"

import "./Exma.vue?vue&type=style&index=0&id=66c84359&lang=scss"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__